"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AuthProvider_1 = require("./AuthProvider");
const ProtectedRoute = ({ children }) => {
    const { user } = (0, AuthProvider_1.useAuth)();
    if (!user) {
        // Redirect to login if the user is not authenticated
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/login", replace: true });
    }
    // Render the protected content if the user is authenticated
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = ProtectedRoute;
